import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeDeleteItemTypesDialog } from "./item-types-delete-slice";
import { db } from "../../../../firebase";
import { useEffect, useState } from "react";
import { deleteItemTypesService } from "./item-types-delete-service";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
      color: "#111111",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
};

const ItemTypesDelete = () => {
    const classes = useStyles();
    const itemTypesData = useSelector((state) => state.itemTypesDeleteSlice.itemTypesDelete);
    const showDialog = useSelector((state) => state.itemTypesDeleteSlice.showDialog);
    const isLoading = useSelector((state) => state.itemTypesDeleteSlice.isLoading);
    const [formData, setFormData ] = useState(initiaFormData);
    const dispatch = useDispatch();

    const itemTypesId = itemTypesData.id;

    // get data
    useEffect(() => {
        if (showDialog) {
            setFormData(itemTypesData);
        }
    }, [showDialog, itemTypesData]);

    // handle delete
    const handleDeleteSubmit = async (e) => {
        try {
            await deleteItemTypesService(dispatch, db, "item_types", itemTypesId)
        } catch (e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to delete."));
            console.error("ItemTypesDelete handleDeleteSubmit error: ", e);
        }

        handleDeleteClose();
    };

    // handle close delete
    const handleDeleteClose = () => {
        dispatch(closeDeleteItemTypesDialog());
    };

    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Delete Item Type
            </DialogTitle>
            <DialogContent>
                <Typography className={classes.text}>
                    {`Do you want to delete '${formData?.code} - ${formData?.name}'?`}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleDeleteSubmit}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Deleting..."
                        ) : (
                            "Delete"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleDeleteClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ItemTypesDelete;